import { FC } from 'react'
import { EmployeeOverviewProjection } from '../../../api/openapi'

interface TeamSummaryIssuesProps {
  employees: EmployeeOverviewProjection[]
}

const TeamSummaryIssues: FC<TeamSummaryIssuesProps> = ({ employees }) => {
  return null
}

export default TeamSummaryIssues
